import React from "react";
import styles from "./Kpis.module.scss"
import Kpi from "./Kpi/Kpi";
import Text from "../UI/Text"

export const kpiUpdate = (state, update) => {

    if ((typeof update !== 'undefined' && update.length > 0) ) {

        const result = state.map((kpi)=>{
            const updated = update.find(updateKpi => updateKpi.title === kpi.title );
            return {...kpi, value: updated ? kpi.value + updated.value : kpi.value }
        })
        return result
    }
    else{
        return state
    }
}

function Kpis({ kpis, markers }) {

    console.log(markers, kpis)


    if (!kpis || kpis.constructor !== Array ) {
        return <Text variant='editor-error'>KPI Editor Structure Failure</Text>
    }
    return <div className={styles.container}>
        {kpis.map( kpi => {

            const marker = markers ? markers.find(marker => marker.title === kpi.title) : false

            return <div key={kpi.title} className={styles.item} >
                <Kpi 
                    caption={kpi.title} 
                    pct={kpi.value} 
                    indicatorPosition={ marker?.value || 0}
                />
            </div>
        })}
    </div>
}
export default Kpis;
